/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Course } from '../../models/course';
import { CourseCriteria } from '../../models/course-criteria';

export interface ApiMasterCourseGetByCriteriaPost$Params {
      body?: CourseCriteria
}

export function apiMasterCourseGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterCourseGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Course>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCourseGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Course>>;
    })
  );
}

apiMasterCourseGetByCriteriaPost.PATH = '/api/Master/Course/GetByCriteria';
